export default __webpack_public_path__ + "static/media/BASSETS-3.de696217.png";